import styled from 'styled-components';

const MenuWrapper = styled.div`
  display: none;
  position: absolute;
  height: auto;
  text-align: center;
  align-items: flex-start;
  justify-content: flex-end;
  z-index: 9999;
  top: 50px;
  right: -1rem;
  width: 400px;
  animation: menuIn .3s ease;

  &:before {
    content: '';
    position: absolute;
    top: -20px;
    right: 18px;
    width: 20px;
    height: 20px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 12px solid #f3f3f3;
  }

  @keyframes menuIn {
    from {
      transform: translateY(-10px);
      opacity: 0;
    }

    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .Menu {
    &-inner {
      font-size: 16px;
      background-color: #fff;
      max-height: 90vh;
      max-width: 800px;
      padding: 0rem;
      width: 100%;
      border-radius: 12px;
      box-shadow: 0 20px 20px rgba(0, 0, 0, .15);
      overflow-y: auto;
      width: 100%;

      > :last-child .NotifWrapper-item {
        border-bottom: 0;
      }
    }
  }

  ${props => props.isOpen && (`
    display: flex;
  `)}
`;

export default MenuWrapper;
